/* ============================================================
   AIRVANCE — JS propio (vanilla, sin librerías)
   Una función init por componente; todas comprueban si su
   elemento existe antes de actuar.
   ============================================================ */
(function () {
  'use strict';

  if (window.__avScriptsLoaded) return;
  window.__avScriptsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll (observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.av-reveal');
    if (!els.length) return;
    document.body.classList.add('av-anim-ready');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('av-in'); });
      return;
    }
    // Lo que ya está en pantalla al cargar se revela sin animación (evita parpadeo del hero)
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.9) el.classList.add('av-in');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('av-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('av-in')) io.observe(el); });
    // Red de seguridad: si algo no dispara, revela todo a los 2,5 s
    setTimeout(function () {
      document.querySelectorAll('.av-reveal:not(.av-in)').forEach(function (el) { el.classList.add('av-in'); });
    }, 2500);
  }

  /* ---- Contadores animados ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-av-count]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) { el.textContent = el.getAttribute('data-av-count') + (el.getAttribute('data-av-suffix') || ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-av-count'));
        var suffix = el.getAttribute('data-av-suffix') || '';
        var decimals = (String(target).split('.')[1] || '').length;
        var start = performance.now();
        var dur = 1400;
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---- Marquesinas: duplicar contenido para bucle continuo ---- */
  function initMarquee() {
    var tracks = document.querySelectorAll('[data-av-marquee]');
    tracks.forEach(function (track) {
      if (track.dataset.avCloned === '1') return;
      var html = track.innerHTML;
      track.innerHTML = html + html;
      track.dataset.avCloned = '1';
    });
  }

  /* ---- Parallax suave del hero ---- */
  function initHeroParallax() {
    var media = document.querySelector('[data-av-parallax]');
    if (!media || reduceMotion) return;
    var ticking = false;
    function update() {
      var rect = media.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.05;
      media.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll('.av-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.av-faq__q');
      var a = item.querySelector('.av-faq__a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('av-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gallery = document.querySelector('[data-av-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-av-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-av-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var root = document.querySelector('[data-av-variants]');
    if (!root) return;
    var dataEl = document.getElementById('av-variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var groups = root.querySelectorAll('[data-av-option-index]');
    // Producto de una sola variante: el precio lo pinta el servidor, no tocamos nada.
    if (!groups.length) return;

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-av-price]');
    var compareEl = root.querySelector('[data-av-compare]');
    var btn = root.querySelector('[data-av-add]');
    var btnLabel = btn ? btn.querySelector('[data-av-add-label]') : null;
    var moneyFormat = root.getAttribute('data-money') || '€{{amount}}';
    var strings = {
      add: (window.variantStrings && window.variantStrings.addToCart) || 'Añadir al carrito',
      soldOut: (window.variantStrings && window.variantStrings.soldOut) || 'Agotado'
    };

    function formatMoney(cents) {
      var num = cents / 100;
      var value;
      try {
        if (/no_decimals/.test(moneyFormat)) {
          value = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 }).format(num);
        } else if (/comma_separator|space_separator/.test(moneyFormat)) {
          value = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
        } else {
          value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
        }
      } catch (e) {
        value = num.toFixed(2);
      }
      return moneyFormat.replace(/\{\{[^}]*\}\}/, value);
    }

    function currentSelection() {
      var sel = [];
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-av-option-index'), 10);
        var active = group.querySelector('[aria-pressed="true"]');
        sel[idx] = active ? active.getAttribute('data-value') : null;
      });
      return sel;
    }

    function update() {
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[i] == null || opt === sel[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (btn) {
        if (match.available) {
          btn.disabled = false;
          if (btnLabel) btnLabel.textContent = strings.add;
        } else {
          btn.disabled = true;
          if (btnLabel) btnLabel.textContent = strings.soldOut;
        }
      }
    }

    groups.forEach(function (group) {
      group.querySelectorAll('[data-value]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('[data-value]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });
    update();
  }

  function boot() {
    initReveal();
    initCounters();
    initMarquee();
    initHeroParallax();
    initFaq();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
